import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import classes from "./Header.module.scss";
import HeaderIcon from "../../static/images/menu-icon.svg";
import icon from "../../static/images/header_icon.svg";
import { useAtom } from "jotai";
import { sideMenuAtom } from "../../state/side-menu/SideMenuAtom";
import { fetchUser } from "../../api/UsersApi";
import { loginCheck } from "../../api/LoginApi";

type HeaderProps = {
  hideMenu?: true;
};

const Header = (props: HeaderProps) => {
  const [state, setState] = useAtom(sideMenuAtom);
  const fetchUserApi = fetchUser();
  const loginCheckApi = loginCheck();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (props.hideMenu || props.hideMenu === null){
      return;
    }
    loginCheckApi.fetch();
  }, []);

  useEffect(() => {
    if (props.hideMenu || props.hideMenu === null) {
      return;
    }
    if (loginCheckApi.state?.data == null) {
      return;
    }
    if (loginCheckApi.state.data?.[0].isLogin) {
      fetchUserApi.fetch();
    }
  }, [loginCheckApi.state, props.hideMenu]);

  // ヘッダーアイコン押下時のページ遷移
    // ログインページ以外は全てマイページに遷移
  const handleImageClick = () => {
    if (location.pathname !== "/login") {
      navigate("/top");
    }
  };

  const openMenu = () => {
    const users = fetchUserApi.state?.data;
    if (!users || users.length === 0) {
      return;
    }
    const user = users[0];
    setState({
      isShow: true,
      userName: user.userName,
      userEmail: user.email,
    });
  };

  return (
    <div className={classes.container}>
      <img
        className={classes.img}
        src={icon}
        alt={icon}
        onClick={handleImageClick}
      />
      {props.hideMenu == null && (
        <>
          <img
            src={HeaderIcon}
            alt={HeaderIcon}
            className={classes.headerIcon}
            onClick={openMenu}
          />
        </>
      )}
    </div>
  );
};

export default Header;
